import { MessageTypes } from '../constants/MessageTypes';
import { addResizeObserver } from './addResizeObserver';
import { onDomReady } from '../helpers/onDomReady';
export class ContainerResizeController {
  constructor({
    applicationController
  }) {
    this.listenForResize = () => {
      addResizeObserver(() => this.handleResize());
    };
    this.getNewHeight = () => {
      return document.body.getBoundingClientRect().height;
    };
    this.handleResize = () => {
      this.applicationController.sendMessage({
        type: MessageTypes.NEW_HEIGHT,
        payload: {
          height: this.getNewHeight()
        }
      });
    };
    this.applicationController = applicationController;
    onDomReady(this.listenForResize);
  }
}